import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import CallCard from "@/components/CallCard";
import { toast } from "sonner";

export default function Challenge() {
  const { id } = useParams();
  const { user } = useAuth();
  const [data, setData] = useState(null);

  const load = () => api.get(`/challenges/${id}`).then(({ data }) => setData(data)).catch(() => setData(false));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [id]);

  const accept = async () => {
    try { await api.post(`/challenges/${id}/accept`); toast.success("Challenge accepted!"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  };

  if (data === false) return <div className="max-w-lg mx-auto px-4 py-24 text-center"><p className="font-display text-3xl font-bold">Challenge not found</p></div>;
  if (!data) return <div className="max-w-lg mx-auto px-4 py-24 text-center text-muted-foreground">Loading…</div>;

  const ch = data.challenge;
  const isOpponent = user && user.user_id === ch.opponent_id;

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <div className="card-brutal card-brutal-lg p-6 bg-brand text-white text-center mb-6">
        <div className="font-display text-lg font-bold uppercase tracking-widest opacity-80">Challenge</div>
        <h1 className="font-display text-3xl font-bold mt-1">“{ch.prediction_text}”</h1>
        <p className="text-sm mt-2 opacity-90">Deadline: {ch.deadline_value || "open"}</p>
      </div>
      {ch.status === "pending" && isOpponent && (
        <button data-testid="accept-challenge-btn" onClick={accept} className="w-full h-12 border-2 border-ink bg-locked text-ink font-bold btn-press shadow-brutal mb-6">Accept the Challenge</button>
      )}
      {ch.status === "pending" && !isOpponent && <p className="text-center text-muted-foreground mb-6">Waiting for the opponent to accept.</p>}
      <div className="grid gap-5">
        {data.creator_call && <div><div className="font-display font-bold mb-2">Position: {ch.creator_position.toUpperCase()}</div><CallCard call={data.creator_call} /></div>}
        {data.opponent_call && <div><div className="font-display font-bold mb-2">Position: {ch.opponent_position.toUpperCase()}</div><CallCard call={data.opponent_call} /></div>}
      </div>
    </div>
  );
}
